import type { ReactNode } from 'react';
import './AnalyticsHeader.css';

interface AnalyticsHeaderProps {
  title: string;
  action: ReactNode;
}

export default function AnalyticsHeader({ title, action }: AnalyticsHeaderProps) {
  return (
    <header className="analytics-header">
      <div className="analytics-header-copy">
        <h1>{title}</h1>
      </div>
      <div className="analytics-header-action">{action}</div>
    </header>
  );
}
